<template>
  <div class="UINotification">
    <Transition name="UINotification__panel" mode="out-in">
      <div v-if="active" :key="active.queueItemId" class="UINotification__item">
        <div class="UINotification__inner">
          <div class="UINotification__icon-wrap">
            <UIIcon :name="active.icon" />
          </div>

          <UIButton
            class="UINotification__close"
            leadIcon="close"
            aria-label="Close"
            theme="secondary"
            size="sm"
            @click="handleClose"
          />

          <div class="UINotification__body">
            <h2>{{ active.title }}</h2>
            <p>{{ active.description }}</p>
          </div>

          <div v-if="active.actionButton" class="UINotification__actions">
            <UIButton
              theme="primary"
              isFull
              class="UINotification__primary"
              @click="onActionClick"
            >
              {{ active.actionButton.label }}
            </UIButton>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { UIButton } from '@foundever/ui-lib'

import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

import { useInAppNotifications } from './composables/useInAppNotifications'

const { active, handlePrimaryAction, handleClose } = useInAppNotifications()

async function onActionClick() {
  await handlePrimaryAction()
}
</script>

<style scoped lang="scss">
.UINotification {
  pointer-events: none;

  .UINotification__item {
    pointer-events: auto;
  }
}

.UINotification__item {
  padding: 1rem;
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 1950;
  background: var(--bg-elevated-primary, var(--bg-primary));
  border: 1px solid var(--border-default);
  border-radius: 1rem;
  max-width: 28.25rem;
  box-sizing: border-box;
  box-shadow: var(--shadow-md);

  .UINotification__inner {
    position: relative;
  }

  .UINotification__icon-wrap {
    padding: 0.5rem;
    border: 1px solid var(--border-default);
    border-radius: 0.5rem;
    width: fit-content;
    --color: var(--icon-primary);
  }

  .UINotification__close {
    position: absolute;
    top: 0.625rem;
    right: 0.625rem;
  }

  .UINotification__body h2 {
    @include font-size-20px;
    font-family: $font-foundever-sans;
    color: var(--text-primary);
    font-weight: 500;
    margin-top: 0.5rem;
  }

  .UINotification__body p {
    @include font-size-14px;
    color: var(--text-primary);
    margin-top: 0.5rem;
  }

  .UINotification__actions {
    margin-top: 0.5rem;
  }

  .UINotification__primary {
    width: 100%;
  }
}

.UINotification__panel-enter-active,
.UINotification__panel-leave-active {
  transition:
    opacity 0.35s ease,
    transform 0.35s ease;
}

.UINotification__panel-enter-from,
.UINotification__panel-leave-to {
  opacity: 0;
  transform: translateX(1.25rem);
}
</style>
